export interface Faq {
  q: string
  a: string[]
  list?: string[]
  afterList?: string
}

export const faqs: Faq[] = [
  {
    q: 'How do I receive Driving Instructor Ready after purchasing?',
    a: ['You receive digital access to the complete material after your purchase is completed.'],
  },
  {
    q: 'Is this an app?',
    a: [
      'No.',
      'Driving Instructor Ready is a digital visual teaching system designed to be easy to consult from a computer, tablet or compatible device.',
    ],
  },
  {
    q: 'Is this a visual product or mostly text?',
    a: [
      'It is designed as a 100% visual teaching system.',
      'The material includes diagrams, road layouts, vehicle trajectories, maneuver sequences, visual progressions, comparisons, instructor cards, correction tools and assessments.',
    ],
  },
  {
    q: 'Does the package include videos?',
    a: [
      'No.',
      'The package does not include videos and videos are not advertised as part of Driving Instructor Ready.',
    ],
  },
  {
    q: 'Is the material in English?',
    a: ['Yes.', 'The complete Worldwide edition is in English.'],
  },
  {
    q: 'Can I edit the material?',
    a: [
      'No.',
      'The material is delivered as finished digital resources for consultation and teaching use.',
    ],
  },
  {
    q: 'Is it only for complete beginners?',
    a: [
      'No.',
      'The system covers students from beginner foundations through more advanced road skills, independent driving and test preparation.',
    ],
  },
  {
    q: "Is the system tied to one country's driving regulations?",
    a: [
      'No single international teaching resource can replace local regulations.',
      'Driving Instructor Ready focuses primarily on broadly applicable teaching concepts such as:',
    ],
    list: [
      'Vehicle control',
      'Observation',
      'Positioning',
      'Maneuver instruction',
      'Student progression',
      'Error correction',
      'Lesson planning',
      'Assessment',
    ],
    afterList:
      'Instructors should adapt relevant sections to local road rules, licensing standards and regulations.',
  },
]
